
import * as React from 'react';
import { Button, Grid, Paper, TextField, WithStyles } from '@material-ui/core';
import { Client } from 'src/api/model';
import StandaloneSearchBox from 'react-google-maps/lib/components/places/StandaloneSearchBox';
import { Dot } from './routeSelector';
import { DirectionsRenderer, GoogleMap, Marker, Polygon } from 'react-google-maps';
import { compose, withProps } from 'recompose';
import withGoogleMap from 'react-google-maps/lib/withGoogleMap';
import DirectionsResult = google.maps.DirectionsResult;
import PlaceResult = google.maps.places.PlaceResult;
import LatLngBounds = google.maps.LatLngBounds;
import { Configurations } from 'src/config';
import withScriptjs from 'react-google-maps/lib/withScriptjs';
import { ClientState } from 'src/store/client';
import { RouteComponentProps } from 'react-router-dom';
import { Theme } from '@material-ui/core/es';
import { mockTheme, toMap } from 'src/utils/utils';
import googleMaps from 'src/api/googleMaps';
import { AppDispatch, IStore } from 'src/store';
import { CompanyActions } from 'src/store/company';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { NotificationType } from 'src/store/notification/notification-actions';
// import { kml } from '@tmcw/togeojson';
// import { kml } from "@tmcw/togeojson";



const styles = (theme: Theme) => ({
  panel: theme.mixins.gutters({
    paddingTop: 16,
    paddingBottom: 16,
    marginTop: theme.spacing.unit * 3,
  }),
  icon: {}
});

const classesType = styles(mockTheme);

interface MapProps {

  zoom: number;
  center: Dot;
  origin?: Dot;
  destiny?: any;
  directions: any;
  zonas: any;

  handleOnClick(e: google.maps.MouseEvent | google.maps.IconMouseEvent): void;

  handleDragEnd(whichOne: string, index?: number): (e: google.maps.MouseEvent) => void;

}

type MarkerType = 'origin' | 'destiny';

export interface LocationData {
  id: number;
  lat: number;
  lng: number;

  street1: string;
  client: {
    user: { name: string, email: string }
    phone: string;

  };

}

const RouteMap: React.SFC<MapProps> = (props: MapProps) => {
  const { center, zoom, destiny, handleDragEnd, handleOnClick, directions, zonas } = props;
  console.log(props, 'props')
  return (<GoogleMap
    defaultZoom={zoom}
    center={center}
    onClick={handleOnClick}
  >
    {
      destiny && destiny.length > 0 && destiny.map((item: any, index: number) => (
        // destiny && (
        <Marker
          draggable
          onDragEnd={handleDragEnd('destiny')}
          position={{ lat: item.lat, lng: item.lng }}
          label={{ text: "V", color: "white" }}
          key={index}
        />
      )
      )
    }

    {
      directions
      &&
      <DirectionsRenderer directions={directions}
        defaultOptions={{ suppressMarkers: true }} />
    }

    {
      zonas &&
      // Asegúrate de tener un array de coordenadas para el polígono
      <Polygon
        paths={zonas}
        options={{
          fillColor: "#000",
          fillOpacity: 0.6,
          strokeColor: "#000",
          strokeOpacity: 1,
          strokeWeight: 1,
        }}
      />
    }


  </GoogleMap>)
};

const EnhancedMap = compose<MapProps, MapProps>(
  withProps({
    containerElement: <div style={{ height: '400px' }} />,
    mapElement: <div style={{ height: '400px' }} />,
  }),
  withGoogleMap
)(RouteMap);

interface LocationProps extends RouteComponentProps<null>, WithStyles<keyof typeof classesType> {
  data: any,
  clients: any;
  client: ClientState;
  actions: CompanyActions;
  // onNewData: (data: RouteData) => void;
}

interface StateMapImporter {
  isDialogOpenClient: boolean;
  filter: string;
  datos: any,
  data: {
    destinyStreet: string;
    clientDocument: string;
    clientLocations: any[];
    visitsDetail: any[];
    selectedClient?: Client;
    searchBounds?: LatLngBounds,
    fullData?: DirectionsResult;
    // otras propiedades de data...
    destiny?: Dot;
    street1?: string;
    street2?: string;
    observation?: string;
    zonas: any[];
  };
  center: Dot,
  clients?: any;
  pageNum: number;
  pageSize: number;
  totalItems: number;
  // otras propiedades del estado...
}

class MapImporter extends React.Component<LocationProps, StateMapImporter> {

  refOrigin: StandaloneSearchBox;
  refDestiny: StandaloneSearchBox;
  fileInput: any;

  constructor(props: LocationProps) {
    super(props);
    this.state = {
      isDialogOpenClient: false,
      filter: '',
      datos: {},
      data: {
        center: '',
        destinyStreet: '',
        clientDocument: '',
        clientLocations: [],
        visitsDetail: [],
        ...props.data,
        fullData: null,
        observation: '',
        zonas: [],
      },
      center: Configurations.prodPy.maps.startingLocation,
      clients: [],
      pageNum: 0,
      pageSize: 5,
      totalItems: 0,
    };

    this.handleOpenDialog = this.handleOpenDialog.bind(this);
    this.handleCloseDialog = this.handleCloseDialog.bind(this);
    this.onDestinyMounted = this.onDestinyMounted.bind(this);
    this.handleOnClick = this.handleOnClick.bind(this);
    this.handleDragEnd = this.handleDragEnd.bind(this);
    this.fireNewDataEvent = this.fireNewDataEvent.bind(this);
    this.kmlToJson = this.kmlToJson.bind(this);

  }

  componentDidMount() {
    const { company } = this.props.location.state;
    console.log(company);
  }


  kmlToJson = async (kml: any) => {
    try {
      const reader = new FileReader();
      reader.onload = (event: any) => {
        console.log(event);
        const parser = new DOMParser();
        const xmlDoc = parser.parseFromString(event.target.result, 'text/xml');
        const placemarks = Array.from(xmlDoc.getElementsByTagName('Placemark'));
        for (const placemark of placemarks) {
          const name = placemark.getElementsByTagName('name')[0].textContent;
          const coordinates = placemark.getElementsByTagName('coordinates')[0].textContent;
          console.log(`Name: ${name}, Coordinates: ${coordinates}`);
        }
      };
    } catch (error) {
      console.error(error);
    }
    // const converted = kml && kml.features && kml.features.map((feature: any) => {
    //   return {
    //     type: feature.geometry.type,
    //     coordinates: feature.geometry.coordinates
    //   }
    // });
    // return converted;
  }

  async requestNewDirections(forceRename: boolean) {
    if (this.state.data.destiny) {
      try {
        const data: DirectionsResult = await googleMaps.getDirections(this.state.data.destiny,
          this.state.data.destiny, 'Paraguay');
        this.handleDirectionsData(data, forceRename);
        console.log("se pidieron nuevas direcciones:" + data);
      } catch (err) {
        console.log(err);
        this.setState({
          data: {
            ...this.state.data,
          }
        });
      }
    }
  }

  handleDirectionsData(data: DirectionsResult, forceNewPosition = true) {

    const route = data &&
      data.routes &&
      data.routes[0];

    const leg = route &&
      route.legs &&
      route.legs[0] &&
      route.legs[0];

    if (!leg) {
      return;
    }

    this.setState({
      data: {
        ...this.state.data,
        destinyStreet: forceNewPosition ? leg.end_address : this.state.data.destinyStreet || leg.end_address,
      }
    });
  }
  fireNewDataEvent(forceRename: boolean) {
    if (this.state.data.destiny) {
      this.requestNewDirections(forceRename).then(() => {
        // this.props.onNewData(this.state.data);
      });
    }
  }

  handleOpenDialog() {
    this.setState({ isDialogOpenClient: true });
  }

  handleCloseDialog() {
    this.setState({ isDialogOpenClient: false });
  }

  selectClient(client: Client) {
    this.setState({ filter: '' });
    this.setState({
      isDialogOpenClient: false,
      data: {
        ...this.state.data,
        selectedClient: client,
      }
    });
    // this.getLocationsByClientDocument(client.document);
  }

  onDestinyMounted(ref: StandaloneSearchBox) {
    console.log(ref, 'refDestiny')
    this.refDestiny = ref;
  }

  setNewPlace(ref: StandaloneSearchBox, type: MarkerType) {


    ref = type === 'origin' ? this.refOrigin : this.refDestiny;

    const places: PlaceResult[] = ref.getPlaces();
    console.log(places, 'places')
    const bounds = new google.maps.LatLngBounds();

    places.forEach((place: PlaceResult) => {
      if (place.geometry.viewport) {
        bounds.union(place.geometry.viewport)
      } else {
        bounds.extend(place.geometry.location)
      }
    });

    const nextMarkers = places.map((place: PlaceResult) => ({
      position: place.geometry.location
    }));
    const nextCenter = nextMarkers && nextMarkers[0] && nextMarkers[0].position || this.state.center;
    const centerDot = new Dot(nextCenter.lat(), nextCenter.lng());

    this.setState({
      data: {
        ...this.state.data,
        [type]: centerDot,
        street1: places[0].formatted_address,
        street2: places[0].vicinity,
        destinyStreet: places[0].formatted_address,

      },
      center: centerDot
    });
    this.fireNewDataEvent(true);

  }


  onPlaceSelected(type: MarkerType) {
    console.log(type, 'fueratype')
    return () => this.setNewPlace(type === 'origin' ? this.refOrigin : this.refDestiny, type);

  }

  handleDragEnd(marker: MarkerType, index?: number) {

    return (e: google.maps.MouseEvent) => {

      this.setState({
        data: {
          ...this.state.data,
          [marker]: new Dot(e.latLng.lat(), e.latLng.lng())

        }
      });
      this.fireNewDataEvent(true);
    }
  }
  handleOnClick(args: google.maps.MouseEvent | google.maps.IconMouseEvent) {
    if (!this.state.data.destiny) {
      this.setState({
        ...this.state,
        data: {
          ...this.state.data,
          destiny: new Dot(args.latLng.lat(), args.latLng.lng())
        }
      });
      this.fireNewDataEvent(true);
      return;
    }

  }

  saveLocation() {
    if (this.props.location.state.company) {
      if (this.state.data.zonas.length > 0 || this.state.data.clientLocations.length > 0) {
        const location = {
          companyId: this.props.location.state.company,
          zonas: this.state.data.zonas,
          clientLocations: this.state.data.clientLocations,
          obs: this.state.data.observation,
        };
        this.props.actions.importLocation(location);
      }
      // if (this.state.data.clientLocations.length > 0) {
      //   // procesar ubicaciones sueltas
      // }
      console.log(this.props, 'PRPS');
      console.log(location, 'LOCATION TO SEND');
    }
  }

  cancelUpload() {
    this.setState({
      data: {
        ...this.state.data,
        zonas: [],
        clientLocations: []
      }
    });

  }

  handleFileUpload = (event: any) => {
    const file = event.target.files[0];

    console.log(file);
    try {
      const reader = new FileReader();
      reader.onload = (evt: any) => {
        console.log(evt);
        const parser = new DOMParser();
        const xmlDoc = parser.parseFromString(evt.target.result, 'text/xml');
        const placemarks = Array.from(xmlDoc.getElementsByTagName('Placemark'));
        placemarks.map(placemark => {
          const poly: any[] = [];
          const polygon = placemark.getElementsByTagName('Polygon')[0];
          console.log(polygon, 'POLYGON')
          if (polygon) {
            // console.log(placemarks, 'placemarks')
            const coords = polygon.getElementsByTagName('coordinates')[0].textContent;
            const coordinatesVal = coords || '';
            const coordinatesArray = coordinatesVal.split(' ');

            coordinatesArray.forEach(coordinatesV => {
              if (coordinatesV.length > 0) {
                const [longi, latitu] = coordinatesV.split(',');
                if (longi && latitu) {
                  poly.push({ lat: parseFloat(latitu), lng: parseFloat(longi) });
                  // this.state.data.zonas.push({ lat: parseFloat(longi), lng: parseFloat(latitu) });
                }
              }
            });
            this.setState({
              data: {
                ...this.state.data,
                zonas: [
                  ...this.state.data.zonas,
                  poly
                ]
              }
            });
            console.log('stateZonas', this.state.data.zonas)
          } else {
            const coordinates = placemark.getElementsByTagName('coordinates')[0].textContent;
            const coordinatesValue = coordinates || '';
            const [longitude, latitude] = coordinatesValue.split(',');

            if (longitude && latitude) {
              this.setState({
                data: {
                  ...this.state.data,
                  clientLocations: [...this.state.data.clientLocations, { lat: parseFloat(latitude), lng: parseFloat(longitude) }]
                }
              });
              console.log('ubicacionesSueltas', this.state.data.clientLocations)
            }
          }
        });
        this.props.actions.throwNoti('Fichero importado', 'Carga realizada', NotificationType.SUCCESS);
        // Promise.all(promises)
        //   .then((responses) => {
        //     console.log(`Se han añadido ${responses.length} ubicaciones.`);
        //     this.props.history.goBack();
        //   })
        //   .catch(error => {
        //     console.error(error);
        //   });
      };
      reader.readAsText(file);

      if (event.target) {
        event.target.value = '';
      }
    } catch (error) {
      console.error(error);
    }
  }

  render() {
    // const data = this.props.location.state;
    return (
      <>
        <Grid container>
          <Grid item md={12}>
            <h3>Importar direcciones</h3>
            <Paper elevation={5} style={{ padding: 10 }}>
              <>
                <Grid item md={12}>
                  <>
                    {
                      <>
                        <label>Importar datos de mapa (.kml)</label> <br />
                        <Button color="primary" style={{ border: '1px solid #000' }} onClick={() => this.fileInput.click()}>
                          Subir archivo
                        </Button>
                        <input
                          type="file"
                          style={{ display: 'none' }}
                          ref={fileInput => this.fileInput = fileInput}
                          accept='.kml'
                          onChange={this.handleFileUpload}
                        />
                      </>
                    }
                    <Grid item md={12}>
                      <TextField
                        id="observation"
                        label="Observación"
                        value={this.state.data.observation}
                        onChange={(e) => this.setState({
                          data: {
                            ...this.state.data,
                            observation: e.target.value
                          }
                        })}
                      />
                    </Grid>
                    {
                      this.state.data.selectedClient &&
                      <StandaloneSearchBox
                        ref={this.onDestinyMounted}
                        bounds={this.state.data.searchBounds}
                        onPlacesChanged={this.onPlaceSelected('destiny')}>

                        <TextField
                          id="destiny"
                          label="Dirección de destino"
                          value={this.state.data.destinyStreet}
                          onChange={(e) => this.setState({
                            data: {
                              ...this.state.data,
                              destinyStreet: e.target.value
                            }
                          })}
                          style={{
                            width: '100%'
                          }}
                          margin="normal"
                          placeholder="Sitio de visita"
                          error={!this.state.data.destinyStreet}
                        />

                      </StandaloneSearchBox>
                    }
                  </>
                  <br />
                  {
                    this.state.data.selectedClient &&
                    <TextField
                      id="observation"
                      label="Observación de dirección"
                      value={this.state.data.observation}
                      onChange={(e) => this.setState({
                        data: {
                          ...this.state.data,
                          observation: e.target.value
                        }
                      })}
                      style={{
                        width: '100%'
                      }}
                      margin="normal"
                      placeholder="Sitio de visita"
                      error={!this.state.data.destinyStreet}
                    />
                  }
                </Grid>
                <Grid item md={12}>
                  <Button color="default" onClick={() => this.cancelUpload()}>{"Cancelar"}</Button>
                  <hr />
                  <EnhancedMap
                    center={this.state.center}
                    zoom={Configurations.prodPy.maps.startingLocation.zoom}
                    destiny={this.state.data.clientLocations}
                    directions={this.state.data.fullData}
                    handleDragEnd={this.handleDragEnd}
                    handleOnClick={this.handleOnClick}
                    zonas={this.state.data.zonas}
                  >
                  </EnhancedMap>

                </Grid>
                <Grid item md={12} style={{ marginTop: '15px' }}>
                  <Button color="secondary" onClick={() => this.props.history.goBack()}>{"Volver"}</Button>
                  <Button color="primary" onClick={() => this.saveLocation()}>{"Guardar"}</Button>
                </Grid>
              </>
            </Paper>
          </Grid>
        </Grid>
      </>
    );
  }
}
const mapStateToProps = (state: IStore, ownProps: LocationProps): LocationProps => ({
  ...ownProps,
});


export default compose<any, LocationProps>(
  withProps((props: LocationProps) => {
    console.log(props, 'props')
    return {
      googleMapURL: `https://maps.googleapis.com/maps/api/js?v=3.exp&libraries=geometry,drawing,places&key=${Configurations.prodPy.maps.key}`,
      loadingElement: <div style={{ height: '400px' }} />,
    }
  }),
  withScriptjs,
  connect(mapStateToProps, (dispatch: AppDispatch) => {
    return {
      actions: bindActionCreators(toMap(CompanyActions), dispatch),
    }
  })
)(MapImporter);




// WEBPACK FOOTER //
// ./src/components/MapImporterComponent.tsx